// PostgreSQL normalizer — routes PG connections through the per-dialect
// tree-sitter grammar fork (resources/tree-sitter/postgres.wasm) instead of
// the legacy unified scanner. PRD: Ralph/SqlGrammar2/PRD.md Slice 3.5.
//
// This module is 5 lines of factory wiring because Slice 3.5 extracted the
// shared per-fork body into `normalize/shared/createForkNormalizer.ts` after
// n=3 forks confirmed ≥ 95% overlap (the threshold set by the Slice 2.5
// PROGRESS log).

import { createForkNormalizer } from '../shared/createForkNormalizer';
import { getPostgresParser } from './parser';

const normalizer = createForkNormalizer({ engine: 'postgres', getParser: getPostgresParser });

export const buildParsedDocument = normalizer.buildParsedDocument;
export const getDocumentStructure = normalizer.getDocumentStructure;

export { setPostgresWasmLoader, getPostgresParser, __resetPostgresParserForTest } from './parser';
export type { PostgresWasmLoader } from './parser';
